import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {QuestionnaireService} from '../../../../services/questionnaire.service';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {MatOptionSelectionChange} from '@angular/material/core';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';
import {MIAHCDResults, Q_MIAH_CD} from '../../../../model/questionnaires/questionnaire-miah-cd';

@Component({
  selector: 'app-questionnaire-miah-cd',
  templateUrl: './questionnaire-miah-cd.component.html',
  styleUrls: ['./questionnaire-miah-cd.component.css']
})
export class QuestionnaireMiahCdComponent implements OnInit {

  qForm: FormGroup;
  dataSource = Q_MIAH_CD;
  notFocused = false;
  submitted = false;
  show = false;
  displayedColumns = ['position', 'question', 'value'];
  results = [];
  q = 'question';
  found = false;

  /// toolbar
  back = true;
  destination = '/questionnaires';
  title = 'MIAH-CD';
  user = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;
  finalScore = 0;
  sliderValue1 = 0;
  sliderValue6 = 0;

  constructor(private questionnaireService: QuestionnaireService,
              public dialog: MatDialog,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void {
    this.qForm = new FormGroup({
      question4: new FormControl({value: ''}, [Validators.required, Validators.min(0)]),
    });
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.dataSource.length; ++i) {
      this.results.push(null);
    }

    this.user = JSON.parse(localStorage.getItem('user'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = this.user.ssn.localeCompare(params.patientSSN) === 0;
      if (params.back.localeCompare('questionnaires') === 0) {
        this.destination = 'questionnaires';
      } else if (params.back.localeCompare('choose-questionnaire') === 0) {
        this.destination = 'choose-questionnaire';
      }
    });
  }

  selectResult($event: MatOptionSelectionChange, value: string, position: number, answers: string[]) {
    if ($event.isUserInput) {
      console.log(value, position, answers);
      if (position === 1 || position === 6 || position === 5) {
        if (this.results[position - 1] !== null) {
          let dec = 1;
          if (position === 5) {
            dec = 0;
          }
          answers.forEach(answer => {
            if (answer === this.results[position - 1]) {
              this.finalScore -= dec;
              console.log('Final Score After:', this.finalScore);
            }
            dec++;
          });
        }
        let inc = 1;
        if (position === 5) {
          inc = 0;
        }
        answers.forEach(answer => {
          if (answer === value) {
            this.finalScore += inc;
          }
          inc++;
        });
      } else if (position === 2 || position === 3) {
        if (this.results[position - 1] !== null) {
          let dec = answers.length - 1;
          answers.forEach(answer => {
            if (answer === this.results[position - 1]) {
              this.finalScore -= dec;
              console.log('Final Score After:', this.finalScore);
            }
            dec--;
          });
        }
        let inc = answers.length - 1;
        answers.forEach(answer => {
          if (answer === value) {
            this.finalScore += inc;
          }
          inc--;
        });
      }
      this.results[position - 1] = value;

      console.log('Risposta: ', value);
      console.log('Risultati: ', this.results);
      console.log('Final Score: ', this.finalScore);
    }
  }

  setResult(position: number) {
    const question = 'question' + position;
    if (position === 4) {
      console.log('FORM VAL', this.qForm.get(question).value);
      console.log('BEFORE INC VAL', this.finalScore);
      if (this.results[position - 1] !== null && this.qForm.get(question).value >= 0) {
        this.finalScore -= parseInt(this.results[position - 1], 10);
        this.results[position - 1] = null;
      }
      if (this.qForm.get(question).value >= 0) {
        this.results[position - 1] = this.qForm.get(question).value.toString();
        this.finalScore += this.qForm.get(question).value;
        console.log('After inc finalScore: ', this.finalScore);
      }
    }
    if (position === 1) {
      if (this.results[position - 1] !== null) {
        this.finalScore -= parseInt(this.results[position - 1], 10);
        this.results[position - 1] = null;
      }
      console.log(this.sliderValue1);
      this.results[position - 1] = this.sliderValue1;
      this.finalScore += this.sliderValue1;
      console.log('After inc finalScore: ', this.finalScore);
    } else if (position === 6) {
      if (this.results[position - 1] !== null) {
        this.finalScore -= parseInt(this.results[position - 1], 10);
        this.results[position - 1] = null;
      }
      console.log(this.sliderValue6);
      this.results[position - 1] = this.sliderValue6;
      this.finalScore += this.sliderValue6;
      console.log('After inc finalScore: ', this.finalScore);
    }
  }

  onSubmit() {
    this.submitted = true;
    this.show = true;
    this.found = false;

    if (this.results.length !== this.dataSource.length) {
      this.show = false;
      this.submitted = false;
      this.found = true;
      const msg = 'Non hai finito di completare il questionario!';
      this.openErrorDialog(msg);
    } else {
      for (const r of this.results) {
        if (r === null) {
          this.show = false;
          this.submitted = false;
          this.found = true;
          const msg = 'Non hai finito di completare il questionario!';
          this.openErrorDialog(msg);
          break;
        }
      }

      if (!this.found) {

        console.log(this.finalScore);
        const resultToSend = new MIAHCDResults(this.doctorID, this.patientSSN, this.results, this.finalScore);
        this.questionnaireService.sendForm(resultToSend, 'miah-cd', this.uuid);
      }
    }
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }

}
